(() => {
  const root = document.documentElement;
  if (!root.dataset.dopeDefaultMode) return;
  const storageKey = 'dope:color-mode:v1';
  const device = window.matchMedia('(prefers-color-scheme: dark)');
  const valid = value => ['light', 'dark', 'system'].includes(value);
  let preference = root.dataset.dopeModePreference || root.dataset.dopeDefaultMode;

  function syncControls() {
    document.querySelectorAll('[data-dope-mode-control]').forEach(control => { control.hidden = false; });
    document.querySelectorAll('[data-dope-mode-toggle]').forEach(control => {
      control.setAttribute('aria-checked', String(root.dataset.dopeColorMode === 'dark'));
    });
    document.querySelectorAll('[data-dope-mode-set]').forEach(control => {
      control.setAttribute('aria-pressed', String(control.dataset.dopeModeSet === preference));
    });
  }

  function apply(value, persist = false) {
    preference = valid(value) ? value : root.dataset.dopeDefaultMode;
    const mode = preference === 'system' ? (device.matches ? 'dark' : 'light') : preference;
    root.dataset.dopeModePreference = preference;
    root.dataset.dopeColorMode = mode;
    const browserColor = document.querySelector('meta[name="theme-color"]');
    if (browserColor) browserColor.content = mode === 'dark' ? '#17151e' : '#f2e8da';
    if (persist) {
      try { localStorage.setItem(storageKey, preference); } catch {}
    }
    syncControls();
    document.dispatchEvent(new CustomEvent('dope:color-mode', { detail: { mode, preference } }));
  }

  document.addEventListener('click', event => {
    const control = event.target.closest('[data-dope-mode-toggle], [data-dope-mode-set]');
    if (!control) return;
    apply(control.hasAttribute('data-dope-mode-toggle') ? (root.dataset.dopeColorMode === 'dark' ? 'light' : 'dark') : control.dataset.dopeModeSet, true);
  }, { capture: true });
  device.addEventListener('change', () => { if (preference === 'system') apply('system'); });
  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) apply(valid(event.newValue) ? event.newValue : root.dataset.dopeDefaultMode);
  });
  document.addEventListener('shopify:section:load', syncControls);
  apply(preference);
})();
